import { Component } from '@angular/core';

@Component({
  selector: 'stc-apps-audit-trail-icon',
  standalone: true,
  templateUrl: './audit-trail-icon.component.svg',
  styleUrl: './audit-trail-icon.component.scss',
})
export class AuditTrailIconComponent {}
